<template>
  <div class="visitors-form-block">
    <div class="visitors-list">
      <div
        v-for="(visitor, visitorIndex) in form.visitors"
        :key="visitorIndex"
        :id="visitorFormId(visitorIndex)"
        class="visitor-block"
      >
        <div v-if="showVisitorBlock">
          <visitor-personal-form-block
            v-model="visitor.personal"
            :form="form"
            :cfg-form-fields="cfgFormFields"
            :approve-form="approveForm"
            :errors="errors"
            :is-single-visitor="isSingleVisitor"
            :nationalities-list="personalNationalities"
            :organization-subjects="organizationSubjectsWithoutFizAndTerminal"
            :organization-subjects-residency="organizationSubjectsResidency"
            :visitor-index="visitorIndex"
            :visitor="visitor"
            :personal-nationalities="personalNationalities"
            :personal-identifications="personalIdentifications"
            :cfg-menu-visitor="cfgMenuVisitor"
            :document-masks="documentMasks"
            :typeaheads="typeaheads"
            :timezone="timezone"
            :can-scud="canScud"
            @remove-visitor="removeVisitor"
            @disable-submit-button="$emit('disable-submit-button')"
            @enable-submit-button="$emit('enable-submit-button')"
            @change-date="$emit('change-date', $event)"
          />
          <visitor-documents-form-block
            :form="form"
            :errors="errors"
            :visitor-index="visitorIndex"
            :visitor="visitor"
            :nationality-documents="nationalityDocuments"
            :personal-nationalities="personalNationalities"
            ref="visitorDocuments"
            @disable-submit-button="$emit('disable-submit-button')"
            @enable-submit-button="$emit('enable-submit-button')"
          />
        </div>
        <transports-form-block
          v-if="showTransportBlock"
          v-model="visitor.transports"
          :form="form"
          :cfg-form-fields="cfgFormFields"
          :errors="errors"
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :cfg-menu-transport="cfgMenuTransport"
          :cfg-menu-visitor="cfgMenuVisitor"
          :terminal-regions="terminalRegions"
          :transport-types="transportTypes"
          :application-purposes="applicationPurposes"
          :transport-colors="transportColors"
          :transport-documents="transportDocuments"
          :sorted-plate-mask="sortedPlateMask"
          :can-scud="canScud"
          :personal-nationalities="personalNationalities"
          :personal-identifications="personalIdentifications"
          :nationality-documents="nationalityDocuments"
          :document-masks="documentMasks"
          :typeaheads="typeaheads"
          :organization-subjects-residency="organizationSubjectsResidency"
          :organization-subjects="organizationSubjects"
          @disable-submit-button="$emit('disable-submit-button')"
          @enable-submit-button="$emit('enable-submit-button')"
        />
      </div>
    </div>
    <div v-if="showAddVisitorButton" class="visitors-add block">
      <div class="text-center">
        <div id="form-visitors-button" class="add-vew-visitor">
          <button
            :errors="errors"
            :disabled="!canAddVisitor"
            type="button"
            class="btn btn-primary btn-primary-blue"
            @click="addVisitor"
          >{{ this.isPassKindMaterial ? 'Добавить предъявителя' : 'Добавить посетителя' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/helpers/api-client/ApiClient'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { cloneObject } from '@/common/helpers'
import mainMixin from '@/common/mixins/mainMixin'
import { PersonalIdentifications } from '@/common/enums/PersonalIdentifications'
import scudMixin from '@/common/mixins/scudMixin'
import TransportsFormBlock from '@/common/components/application/form-blocks/transports/TransportsFormBlock'
import Visitor from '@/common/classes/Visitor'
import VisitorDocumentsFormBlock from '@/common/components/application/form-blocks/visitors/VisitorDocumentsFormBlock'
import VisitorPersonalFormBlock from './VisitorPersonalFormBlock'
import { PassKinds } from '@/common/enums/PassKinds';

export default {
  name: 'VisitorsFormBlock',

  components: {
    VisitorPersonalFormBlock,
    VisitorDocumentsFormBlock,
    TransportsFormBlock
  },

  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    scudMixin
  ],

  model: {
    prop: 'visitors',
    event: 'change-visitors'
  },

  props: {
    documentMasks: {
      type: Array,
      default: () => []
    },

    nationalitiesList: {
      default: []
    },

    nationalityDocuments: {
      type: Array,
      default: () => []
    },

    organizationSubjects: {
      type: Array,
      default: () => []
    },

    organizationSubjectsResidency: {
      default: []
    },

    personalIdentifications: {
      type: Array,
      default: () => []
    },

    applicationPurposes: {
      type: [Array, Object],
      default: () => []
    },

    personalNationalities: {
      type: Array,
      default: () => []
    },

    transportColors: {
      type: Array,
      default: () => [],
      required: true
    },

    transportDocuments: {
      type: Array,
      default: () => []
    },

    transportTypes: {
      type: Array,
      default: () => {}
    },

    typeaheads: {
      type: Object,
      default: () => ({})
    },

    visitors: {
      type: Array,
      required: true
    },

    cfgFormFields: {
      type: [Array, Object],
      default: () => []
    }
  },

  data: () => {
    return {
      cfgMenuVisitor: [],
      cfgMenuTransport: [],
      sortedPlateMask: {}
    }
  },

  computed: {
    canAddVisitor() {
      let maxVisitorsCount = Number(this.configuration.form_visitors)
      let currentVisitorsCount = this.visitors.length
      return currentVisitorsCount < maxVisitorsCount
    },

    checkTypesWithPersonal() {
      return !this.isPassKindTransport
    },

    applicationPurpose() {
      return this.applicationPurposes[this.form.application.application_group_purpose_id]
    },

    isSingleVisitor() {
      return this.visitors.length === 1
    },

    organizationSubjectsWithoutFizAndTerminal() {
      return this.organizationSubjects.filter(
        organizationSubjet => organizationSubjet.id !== 'fiz' && organizationSubjet.id !== 'terminal'
      )
    },

    showVisitorBlock() {
      return this.form.application?.pass_kind !== PassKinds.TRANSPORT
    },

    showTransportBlock() {
      return !this.isPassKindPedestrian
    },

    showAddVisitorButton() {
      return (this.checkTypesWithPersonal && this.isView === false && this.canAddVisitor)
    },

    timezone() {
      return String(this.configuration.default_timezone ?? 'Europe/Moscow')
    }
  },

  async created() {
    await this.fetchTransportPlateMask().then()
  },

  mounted() {
    this.fetchCfgMenuVisitor()
    this.fetchCfgMenuTransport()
  },

  methods: {
    addVisitor() {
      if (!this.canAddVisitor) {
        return
      }

      const newVisitor = cloneObject(new Visitor())

      if (this.form.visitors[0]) {
        newVisitor.personal.nationality_id = this.form.visitors[0].personal.nationality_id
        newVisitor.personal.identification_id = this.form.visitors[0].personal.identification_id
      }

      if (this.form.organization.subject_id === 'gko') {
        newVisitor.personal.identification_id = PersonalIdentifications.SERVICE_IDENTITY
      }
      this.visitors.push(newVisitor)
      this.$emit('handle-terminal-region')
      this.scrollToLastVisitor()
    },

    async fetchCfgMenuTransport() {
      await ApiClient.cfgMenuData({
        id: this.form.application.id,
        type: 'transport'
      }).then((response) => {
        this.cfgMenuTransport = response.data.data
      })
    },

    async fetchCfgMenuVisitor() {
      await ApiClient.cfgMenuData({
        id: this.form.application.id,
        type: 'visitor'
      }).then((response) => {
        this.cfgMenuVisitor = response.data.data
      })
    },

    async fetchTransportPlateMask() {
      await ApiClient.transportPlateMaskData().then((response) => {
        this.sortedPlateMask = response.data.data
      })
    },

    removeVisitor(visitorIndex) {
      this.visitors.splice(visitorIndex, 1)
      this.scrollToLastVisitor()
    },

    scrollToLastVisitor() {
      if (this.visitors.length === 0) {
        return
      }

      this.$nextTick(() => {
        this.$scrollTo('#' + this.visitorFormId(this.visitors.length - 1), 100, {
          offset: -90
        })
      })
    },

    visitorFormId(visitorIndex) {
      return `visitor-${visitorIndex}`
    }
  }
}
</script>
